import { DirectiveBinding, ObjectDirective } from 'vue';

// data-b-expose-id：标记元素对应的上报 spm id
// data-b-expose-data：标记上报时的额外数据，会放在message字段内
// data-b-expose-key：不会包括在上报信息里，用于标记列表中相同 spm id 的不同元素

const exposeMount = (el: HTMLElement, binding: DirectiveBinding) => {
  if (binding.value?.id) el.dataset.bExposeId = binding.value.id;
  if (binding.value?.key) el.dataset.bExposeKey = binding.value.key;
  if (binding.value?.data) el.dataset.bExposeData = binding.value.data;
};

const Expose: ObjectDirective = {
  mounted: exposeMount,
  updated: exposeMount
};

export type ExposeFn = (pos: number) => { id: string; key?: string; data?: unknown } | null

export const createExposeMeta = <T>(id: string, key?: string, data?: T) => {
  return {
    id,
    key,
    data: JSON.stringify(data)
  };
};

export default Expose;
